import { ProductCatalogCompatibilityResponse } from "@vp/hamilton-service-clients/dist/src/models/ProductCatalog/ProductCatalogCompatibility";

const VALUE_SEPARATOR = "::";
const OPTION_SEPARATOR = "||";

export class CompatibilityCache {
  private compatibilities: { [serializedKey: string]: ProductCatalogCompatibilityResponse };
  private static instance: CompatibilityCache;

  constructor() {
    this.compatibilities = {};
  }

  static getInstance(): CompatibilityCache {
    if (!CompatibilityCache.instance) {
      CompatibilityCache.instance = new CompatibilityCache();
    }
    return CompatibilityCache.instance;
  }

  serializeSelection(coreProductId: string, selections: { [key: string]: string }): string {
    const orderedSelections: { [key: string]: string } = {};
    Object.keys(selections)
      .sort()
      .map(key => {
        orderedSelections[key] = selections[key];
      });

    const serializedString = Object.keys(orderedSelections)
      .reduce((result: string[], key: string): string[] => {
        result.push(`${key}${VALUE_SEPARATOR}${orderedSelections[key]}`);
        return result;
      }, [])
      .join(OPTION_SEPARATOR);
    return `${coreProductId}|${serializedString}`;
  }

  public getCompatibleValues(
    coreProductId: string,
    selections: {
      [key: string]: string;
    }
  ): ProductCatalogCompatibilityResponse | undefined {
    const key = this.serializeSelection(coreProductId, selections);
    return this.compatibilities[key] || undefined;
  }

  public setCompatibleValues(
    coreProductId: string,
    selections: { [key: string]: string },
    compatibility: ProductCatalogCompatibilityResponse
  ) {
    this.compatibilities[this.serializeSelection(coreProductId, selections)] = compatibility;
  }
}
